// extracted by mini-css-extract-plugin
export default {"block":"Geography_block__gSxYG","row":"Geography_row__VLi+4","col":"Geography_col__FAyEO","label":"Geography_label__6WJw1","blockTiny":"Geography_blockTiny__hUI+Q"};